var _path, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7607 18L11.3406 18.5599L11.7543 18.8703L12.1725 18.5661L11.7607 18ZM11.7607 18C12.1725 18.5661 12.1726 18.566 12.1728 18.5658L12.1732 18.5656L12.1742 18.5648L12.1774 18.5625L12.188 18.5546L12.2259 18.5265C12.2582 18.5022 12.3045 18.4671 12.363 18.4217C12.48 18.3309 12.646 18.1989 12.8466 18.0307C13.2472 17.6949 13.7892 17.2117 14.356 16.6211C15.4695 15.4608 16.7634 13.7999 17.1699 11.97L17.1715 11.9627L17.173 11.9554C17.5819 9.91013 16.9665 8.22487 15.857 7.0622C14.7672 5.92016 13.2193 5.3 11.7607 5.3C8.84245 5.3 5.92481 7.80223 6.33911 11.5318C6.54744 13.4073 7.86959 15.1868 9.02038 16.4301C9.61058 17.0677 10.1872 17.5973 10.616 17.9674C10.8307 18.1528 11.0095 18.2991 11.1356 18.3998C11.1986 18.4502 11.2486 18.4893 11.2835 18.5162L11.3241 18.5475L11.3355 18.5561L11.3388 18.5586L11.3399 18.5594L11.3403 18.5597C11.3405 18.5598 11.3406 18.5599 11.7607 18Z",
    stroke: "#2F353B",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8,
    cy: 10.8,
    r: 1.5,
    fill: "#E34B34",
    stroke: "#E34B34",
    strokeWidth: 1.4
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.8da3ad20.svg";
export { ForwardRef as ReactComponent };